import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import React from 'react'

export default function SupRadio({ onChange, item }) {
  return (
    <>
      <FormControl>
        <RadioGroup
          row

          value={item?.radioboxValue}
          onChange={(e) => {
            if (e.target.value === 'true') {
              onChange(true)
            } else {
              onChange(false)
            }
          }}
        >
          <FormControlLabel value={true} control={<Radio size='small' />} label="Yes" disabled={item.disabled} />
          <FormControlLabel value={false} control={<Radio size='small' />} label="No" disabled={item.disabled} />
        </RadioGroup>
      </FormControl>
    </>
  )
}
